import React, { useContext } from 'react';
import { connect } from 'react-redux';

import { useTranslation } from '@lt/localization';

// import { pushExploreLinkClicked } from 'src/routes/SeoApp/utils/gtmEvents';
import { MobileContext } from '../../../../domain/context/MobileContext';

// Selectors:
import {
  getLinkedDestionationRegionList,
  getLinkedMetaregionsList,
  getLinkedModifiers,
  getResortListTitle,
} from '../../../../domain/state/linked/selectors';

// Models:
import type { IDestinationRegion } from './Models/dectionation-region.model';
import type { IMetaRegion } from './Models/metaregion.model';
import type { IModifier } from './Models/modifier.model';

// Components:
import { ResortListDesktop } from './ResortList.desktop';
import { ResortListMobile } from './ResortList.mobile';

interface IStateProps {
  linkedDestinationRegions: IDestinationRegion[];
  linkedMetaRegions: IMetaRegion[];
  linkedModifiers: IModifier[];
  linkedResortListTitle: string;
}

const mapStateToProps = (state) => ({
  linkedDestinationRegions: getLinkedDestionationRegionList(state),
  // ?.map(
  //   (item) => ({
  //     ...item,
  //     onClick: () => {
  //       pushExploreLinkClicked({
  //         custom_params: { type: 'other_regions' },
  //       });
  //     },
  //   }),
  // ),
  linkedMetaRegions: getLinkedMetaregionsList(state),
  linkedModifiers: getLinkedModifiers(state),
  linkedResortListTitle: getResortListTitle(state),
});

interface IOwnProps {
  mapExpanded: boolean;
}

export const ResortList = connect<IStateProps, TPseudoObject, IOwnProps>(
  mapStateToProps,
)((props: IStateProps & IOwnProps) => {
  const {
    linkedDestinationRegions,
    linkedMetaRegions,
    linkedModifiers,
    linkedResortListTitle,
    mapExpanded,
  } = props;

  const { t } = useTranslation();

  const isMobile = useContext(MobileContext);

  const Lists = [
    {
      name: t('explore.links.resortList.listNames.popularRequests'),
      elements: linkedModifiers,
    },
    {
      name: t('explore.links.resortList.listNames.restTypes'),
      elements: linkedMetaRegions,
    },
    {
      name: t('explore.links.resortList.listNames.regions'),
      elements: linkedDestinationRegions,
    },
  ];

  return isMobile || mapExpanded ? (
    <ResortListMobile
      linkedResortListTitle={linkedResortListTitle}
      lists={Lists}
    />
  ) : (
    <ResortListDesktop
      linkedResortListTitle={linkedResortListTitle}
      lists={Lists}
    />
  );
});
